<template>
  <!-- eslint-disable max-len -->
  <main class="u-container">
    <section>
      <h1
        class="font-bold"
      >
        USPS Change-of-Address<sup>®</sup>
      </h1>
    </section>
    <section
      v-if="needsConfirmation"
      class="mt-5"
    >
      <p class="font-bold">
        To successfully submit your request, click the button below to confirm and file your Change-of-Address order.
      </p>
      <p class="mt-2">
        Date of Transaction: {{ coaCompletedDate | formatDateStr }}<br>
        Name: {{ firstName }} {{ lastName }}<br>
        Move Type: {{ moverType }}<br>
        Move Effective Date: {{ startDate | formatDateStr }}<br>
      </p>
      <button
        id="confirm-mcoa"
        class="c-btn mt-2"
        @click="confirm"
      >
        Confirm
      </button>
    </section>
    <section
      v-else
      class="mt-5"
    >
      <p class="font-bold">
        Your Change-of-Address has been confirmed.
      </p>
    </section>
  </main>
</template>

<script>
import { format, parse } from 'date-fns';
import pageView from '../../mixins/pageView';
import { consumeMilitaryConfirmationInvitation } from '../../utils/militaryConfirmationInvitation';

export default {
  name: 'DesktopMilitaryConfirmation',
  filters: {
    formatDateStr(dateStr) {
      if (!dateStr) return '';

      return format(parse(dateStr, 'yyyy-MM-dd', new Date()), 'MM/dd/yyyy');
    },
  },
  mixins: [pageView],
  data() {
    return {
      coa: {},
      mover: {},
      needsConfirmation: true,
    };
  },
  computed: {
    coaCompletedDate() {
      return this.coa?.completedDate;
    },
    moverType() {
      return this.coa?.moverType;
    },
    startDate() {
      return this.coa?.startDate;
    },
    firstName() {
      return this.mover?.firstName;
    },
    lastName() {
      return this.mover?.lastName;
    },
  },
  async mounted() {
    const invitationToken = consumeMilitaryConfirmationInvitation();
    this.pageView();
    if (invitationToken) {
      const confirmation = await this.$coa.militaryConfirmationExchange(invitationToken);
      await this.hydrateConfirmation(confirmation, true);
      return;
    }

    const { coaUUID } = this.$route.params;
    if (coaUUID) {
      this.$coa.coaUUID = coaUUID;
      const confirmation = await this.$coa.militaryConfirmationGet(coaUUID);
      await this.hydrateConfirmation(confirmation, false);
    }
  },
  methods: {
    async hydrateConfirmation(confirmation, replaceRoute) {
      if (!confirmation?.orderUuid) return;

      const {
        orderUuid,
        completedDate,
        moverType,
        startDate,
        firstName,
        lastName,
      } = confirmation;
      this.$coa.coaUUID = orderUuid;
      this.coa = { completedDate, moverType, startDate };
      this.mover = { firstName, lastName };
      if (replaceRoute) {
        await this.$router.replace({
          name: 'military-confirm',
          params: { coaUUID: orderUuid },
        });
      }
    },
    async confirm() {
      await this.$coa.confirmMCOA();
      this.needsConfirmation = false;
    },
  },
};
</script>
